module.exports = __webpack_public_path__ + "img/fail-error.5971cf60f7204fe0646b26df5b87da7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fail-error.png
// module id = 142
// module chunks = 0